<i18n lang="yaml">
zh:
  upload_select_file: "选择文件"
  upload_only_support: "仅支持"
  upload_file: "文件"
  upload_file_not_exceed: "文件大小不超过"
  check_file_content: "检查文件内容"
  upload_if_garbled: "如果文件内容出现乱码，请"
  upload_view_help: "查看帮助"
  check_chapter_count: "检查章节数量"
  chapter_zero_exception: "章节数为0的异常情况"
  check_chapter_title_rule: "检查章节标题规则"
  chapter_title_single_line: "章节标题必须单独一行"
  chapter_title_format: "章节标题格式"
  chapter_number_format: "数字格式：第1章 章节标题"
  chapter_number_title_format: "数字标题格式：1 章节标题"
  chapter_mixed_format: "混合格式：第一章 章节标题"
  chapter_mixed_title_format: "混合标题格式：Chapter 1 章节标题"
  chapter_english_number: "英文数字：Chapter 1"
  chapter_english_chapter: "英文章节：Chapter"
  check_article_format: "检查文章格式"
  upload_chapter_count: "上传文件章节数量："
  chapter: "章"
  file_too_large: "文件过大"
  upload_failed: "上传失败"
  chinese_character_count: "中文字数："
  file_read_error: "读取文件时出错："
  upload_progress: "上传进度："
  upload_complete: "上传结束："
  not_doc_file: "This is not a .doc or .docx file."

en:
  upload_select_file: "Select File"
  upload_only_support: "Only supports"
  upload_file: "file"
  upload_file_not_exceed: "File size does not exceed"
  check_file_content: "Check File Content"
  upload_if_garbled: "If file content appears garbled, please"
  upload_view_help: "View Help"
  check_chapter_count: "Check Chapter Count"
  chapter_zero_exception: "Exception when chapter count is 0"
  check_chapter_title_rule: "Check Chapter Title Rules"
  chapter_title_single_line: "Chapter title must be on a separate line"
  chapter_title_format: "Chapter title format"
  chapter_number_format: "Number format: Chapter 1 Chapter Title"
  chapter_number_title_format: "Number title format: 1 Chapter Title"
  chapter_mixed_format: "Mixed format: Chapter One Chapter Title"
  chapter_mixed_title_format: "Mixed title format: Chapter 1 Chapter Title"
  chapter_english_number: "English number: Chapter 1"
  chapter_english_chapter: "English chapter: Chapter"
  check_article_format: "Check Article Format"
  upload_chapter_count: "Upload file chapter count:"
  chapter: "Chapter"
  file_too_large: "File too large"
  upload_failed: "Upload failed"
  chinese_character_count: "Chinese character count:"
  file_read_error: "Error reading file:"
  upload_progress: "Upload progress:"
  upload_complete: "Upload complete:"
  not_doc_file: "This is not a .doc or .docx file."
</i18n>

<template>
<div :style="{'width': drawerWidth}">
    <el-upload
      class="ly-uploader"
      action="#"
      :before-upload="handleBeforeUpload"
      :on-preview="handlePreview"
      :on-success="handlePreview"
      :on-remove="handleRemove"
      :file-list="fileList"
      :on-progress="handleProgress"
      :on-change="handleChange"
      :on-exceed="handleExceed"
      list-type="text"
      :show-file-list="false"
      accept=".txt,.doc,.docx"
      :limit="limit"
      :http-request="httpRequest">
      <div class="el-upload__text">
        <div style="display: flex;">
          <el-button class="el-button-dashed mly-border-radius-12" style="padding: 10px 55px;color: #0052D9;font-size: 12px;font-weight: 400;" icon="el-icon-upload2" :loading="loadingFlag" plain>{{ $t('upload_select_file') }}</el-button>
        </div>
      </div>
      <div style="line-height: 1rem !important;color: rgba(0, 0, 0, .4);margin-bottom: .25rem;" class="el-upload__tip" slot="tip">
        {{ $t('upload_only_support') }}<span style="color: #125FDC;padding: 0 .25rem;">txt, doc, docx</span>{{ $t('upload_file') }}，{{ $t('upload_file_not_exceed') }}<span style="color: #125FDC;padding: 0 .25rem;">300MB</span>

        <div style="height: 100px;" v-show="(!loadingFlag)&&fileList && fileList.length == 0"></div>
        <el-skeleton v-show="loadingFlag" :rows="3" style="margin-top: 1rem;" animated/>

        <!-- error -->
        <div v-if="errorFlag" class="icon-bg-error-outer">
            <div class="icon-bg-error d-flex flex-between flex-y-center">
                <span>{{fileList && fileList.length > 0 ? fileList[0].name : $t('upload_file_not_exceed')}}</span>
                <i class="el-icon-error" style="color: red;font-size: 20px;"></i>
            </div>
        </div>
        <!-- success -->
        <div v-if="successFlag" class="icon-bg-success-outer">
            <div class="icon-bg-success d-flex flex-between flex-y-center">
                <span>{{fileList && fileList.length > 0 ? fileList[0].name : $t('upload_file_not_exceed')}}</span>
                <i class="el-icon-success" style="color: green;font-size: 20px;"></i>
            </div>
        </div>
        <!-- file check -->
        <div v-if="successFlag" class="file-check">
          <div class="d-flex">
            <div class="file-check-circle">1</div>
            <div style="padding-left: 6px;color: #0052D9;font-weight: 600;font-size: 14px;
    display: flex;
    align-items: center;">{{ $t('check_file_content') }}</div>
          </div>
          <div class="d-flex" style="border-radius: 6px;">
            <div class="file-check-bar">
              <div class="file-check-bar-inner"></div>
            </div>
            <div style="padding-left: 6px;">
              <div style="font-size: 10px;color: rgba(0,0,0,0.4);padding-top: 10px; padding-bottom: 6px;">{{ $t('upload_if_garbled') }}<a href="https://qcnx120ai68z.feishu.cn/wiki/D1Qkw0Kqoic66MkvL0NcAw8gnqg#share-ZwSrd7wwIomZ5dxzTgncH4Nsnyb" target="_blank" style="color: #125FDC;">{{ $t('upload_view_help') }}</a></div>
              <div v-html="replaceLineBreaks(content)"
                style="border-radius: 12px; background: #FFFFFF;
                text-align: justify;color: rgba(0,0,0,0.8);
                box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.03);padding: 1rem;margin-bottom: 10px;">

              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="file-check-circle">2</div>
            <div style="padding-left: 6px;width: 100%;">
              <div style="color: #0052D9;font-weight: 600;font-size: 14px;height: 20px;
    display: flex;
    align-items: center;">{{ $t('check_chapter_count') }}</div>
              <div style="font-size: 10px;color: rgba(0,0,0,0.4);padding-top: 10px; padding-bottom: 6px;">{{ $t('chapter_zero_exception') }}
                <a style="color: #125FDC;">
                  <el-tooltip placement="top" style="display: inline-block;">
                    <div slot="content" style="line-height: 20px;">
                      {{ $t('check_chapter_title_rule') }}<br>
                      *1. {{ $t('chapter_title_single_line') }} <br>
                      *2. {{ $t('chapter_title_format') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_number_format') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_number_title_format') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_mixed_format') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_mixed_title_format') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_english_number') }} <br>
                      &nbsp;&nbsp;{{ $t('chapter_english_chapter') }}
                    </div>
                    <div style="">
                      {{ $t('check_article_format') }}
                    </div>
                  </el-tooltip>

                </a>
              </div>
              <div style="color: rgba(0,0,0,0.8);border-radius: 12px; background: #FFFFFF;
                text-align: justify;
                box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.03);padding: 1rem;">{{ $t('upload_chapter_count') }}<a style="color: #125FDC; cursor: default;">{{zhanggangNumber}}</a> {{ $t('chapter') }}</div>

            </div>
          </div>
        </div>
      </div>

    </el-upload>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import * as AliossApi from '@/api/alioss'
import * as FileApi from '@/api/file'
const OSS = require('ali-oss')
export default {
  name: 'RichEditor',
  props: {
    picSize: {
      type: String,
      default: '160x160'
    },
    url: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    if (this.url) {
      this.url.split(',').forEach((item, inex) => {
        this.fileList.push({ name: '', url: item })
      })
    }
  },
  computed: {
    ...mapState(['successFlag']),
    drawerWidth() {
      return window.innerWidth <= 768 ? '100%' : '100%'
    }
  },
  data() {
    return {
      fileList: [],
      loadingFlag: false,
      errorFlag: false,
      content: '',
      zhanggangNumber: 0,
      progressPercent: 0
    }
  },
  methods: {
    ...mapMutations(['setSuccessFlag']),
    handleProgress(event, file, fileList) {
      console.log('handleProgress', event, file)
      this.progressPercent = Math.floor(event.percent)
    },
    handleChange(file, fileList) {
      console.log('handleChange', file, fileList)
    },
    replaceLineBreaks(str) {
      return str ? str.replace(/\\n/g, '\n').replace(/\n/g, '<br>') : ''
    },
    async handleExceed(files, fileList) {
      // this.$message.warning(`Currently limited to selecting 1 file, this time selected ${files.length} files, total selected ${files.length + fileList.length} files`);
      const p1 = Object.assign({}, files)
      const p2 = Object.assign({}, fileList)
      console.log('handleExceed', p1, p2)
      if (p1[0].name === p2[0].name && p1[0].size === p2[0].size) {
        return
      }
      if (fileList.length >= 1) {
        fileList.splice(0, 1, files[0])
      }
      this.fileList = fileList
      this.httpRequest({ file: this.fileList[0] })
    },
    readAsTextSync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsText(file);
      });
    },

    // 使用 async/await 语法来“同步”读取文件
    async readFileAndCountChineseCharacters(file) {
      try {
        const content = await this.readAsTextSync(file);
        const count = content.length;
        console.log(this.$t('chinese_character_count'), count);
        return count
      } catch (error) {
        console.error(this.$t('file_read_error'), error);
      }
    },
    async httpRequest(item) {
      this.loadingFlag = true
      console.log('httpRequest', item);
      var file = item.file

      // File size
      const maxSize = 300 * 1024 * 1024; // 10m
      // const maxSize = 10 * 1024; // 10k
      if (file.size > maxSize) {
        this.fileList = []
        this.$message.error(this.$t('file_too_large'));
        return false; // Prevent upload
      }
      // Word count
      const wordCount = 0
      // if(file){
      //   wordCount = await this.readFileAndCountChineseCharacters(file);
      // }
      // console.log('Word count:', wordCount);
      // if (wordCount > 30000) {
      //   this.fileList = []
      //   this.$message.error('Word count should not exceed 30,000');
      //   return false; // Prevent upload
      // }

      let fileType = file.type.toLowerCase()
      let ext=''
      if(fileType.indexOf('text') >= 0){
        ext = '.txt';
      }else if(fileType === 'application/msword' || fileType === 'application/wps-writer'){
        ext = '.doc';
      }else if(fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
        ext = '.docx';
      } else {
        console.log(this.$t('not_doc_file'));
      }

      let storeAs = process.env.VUE_APP_CURRENTMODE + '/' + Number(new Date().getTime()/(3600*24*7*1000)).toFixed(0) + '/' + this.guid().replace(/-/g,'') + ext
      console.log(fileType,storeAs);

      let res = await AliossApi.ststoken()
      const result = res.data.data
      const client = new OSS({
        accessKeyId: result.accessKeyId,
        accessKeySecret: result.accessKeySecret,
        stsToken: result.stsToken,
        endpoint: result.endpoint,
        bucket: result.bucket
      })
      client.multipartUpload(storeAs, file, {
        progress: (percentage) => {
          console.log(`${this.$t('upload_progress')}${percentage * 100}% file: `, file);
        }
      }).then(result => {
        console.log('multipartUpload result', result);
        let picUrl = result.res.requestUrls[0];
        picUrl = picUrl.split('?')[0];
        this.fileList = [{name: file.name, url: picUrl}]
        console.log('picUrl', picUrl, this.fileList);

        let url =  picUrl.split("?")[0];
        if (url != null && url.length > 0) {
          // Upload successful
          console.log(this.$t('upload_complete'), this.$parent.$parent.$parent.$parent);
          if (this.$parent.$parent.$parent.$parent.getFile) {
            this.$parent.$parent.$parent.$parent.getFile();
          }
          // Check format
          let params = {
            fromType: 'check_file',
            url: url
          }
          FileApi.create(params).then(res => {
             console.log('create file', res, 'loadingFlag', this.loadingFlag);
             let result = res.data
             this.loadingFlag = false
             if (result.code === -1) {
               // this.$message.error('Upload failed! Network issue, please re-upload the file!')
               this.errorFlag = true
               this.setSuccessFlag(false)
             } else {
               this.zhanggangNumber = result.data.zhanggangNumber
               this.setSuccessFlag(true)
               this.errorFlag = false
             }
             this.content = result.data.content

          });
        } else {
          this.$message.error(this.$t('upload_failed'));
          this.errorFlag = true
          this.setSuccessFlag(false)
          this.loadingFlag = false
        }
      }).catch(function(err) {
        console.log('upload', err);
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      let temp = []
      this.fileList = temp.concat(fileList)
      if(this.$parent.$parent.$parent.$parent.getFile){
        this.$parent.$parent.$parent.$parent.getFile();
      }
    },
    handlePreview() {
      console.log('handlePreview', 1);
      // picUrl
    },
    getFile() {
      if(this.fileList.length > 0) {
        return this.fileList[0]
      } else {
        return {};
      }
    },
    async handleBeforeUpload(file) {

      return true; // Allow upload
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
       (c) => {
          var r = (Math.random() * 16) | 0
          var v = c == 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  width: 100% !important;
  text-align: left;
}
/deep/ .el-upload-dragger {
  width: 100% !important;
}

.icon-bg-error-outer {
  margin-bottom: 10px;
  margin-top: 6px;
  background: #FFF4F3;
  border-radius: 12px;
}
.icon-bg-error {
  background-image: url('../../assets/icon-upload-bg.png');
  background-repeat: no-repeat;
    background-position: 0px 0px;
    background-size: 40px 40px;
    border-radius: 6px;
    padding-left: 40px;
    padding-right: 12px;
    line-height: 48px;
}
.icon-bg-success-outer {
  margin-bottom: 10px;
  margin-top: 6px;
  background: rgba(191,241,210,0.22);
  border-radius: 12px;
}
.icon-bg-success {
  background-image: url('../../assets/icon-upload-bg-success.png');
  background-repeat: no-repeat;
    background-position: 0px 12px;
    background-size: 40px 40px;
    border-radius: 6px;
    padding-left: 40px;
    padding-right: 12px;
    line-height: 48px;
}
.file-check {
   padding: 1rem;
   background: #FAFAFD;
   border-radius: 12px;
   &-circle {
     width: 20px;
     height: 20px;
     display: flex;
     align-items: center;
     justify-content: center;
     background: #0052D9;
     color: #FFFFFF;
     border-radius: 50%;
   }
   &-bar {
     width: 20px;
     padding: 10px 10px;
     &-inner{
       width: 1px;
       background: #0052D9;
       height: 100%;
     }
   }
}
/* Define a class selector that can be added to buttons that need dashed borders */
.el-button-dashed {
  border-style: dashed; /* Set border style to dashed */
  border-width: 1px; /* Set border width */
  border-color: #dcdfe6; /* Set border color, can be adjusted as needed */
}

/* If you want to change the border style in hover state, you can add the following styles */
.el-button-dashed:hover {
  border-color: #409eff; /* Border color on hover */
}
</style>
